import cn from 'classnames';
import { FC, HTMLAttributes, ReactNode } from 'react';

interface SimpleHeadlineProps extends Omit<HTMLAttributes<HTMLParagraphElement>, 'title'> {
  title: ReactNode;
}

/**
 * Simple headline component that displays a headline with a given title.
 */
const SimpleHeadline: FC<SimpleHeadlineProps> = ({ title, ...props }) => (
  <p
    {...props}
    className={cn('text-text-light-bg-primary mindset-24 lg:mindset-28', props.className)}
  >
    {title}
  </p>
);

export default SimpleHeadline;
